
import PaymentSuccessImage from "~/assets/images/business-type-cloud-kitchen.png";
import AnimatedCheckMark from "../common/animated-check-mark.vue";
export default {
  props: {
    dialog: true
  },
  components: {
    AnimatedCheckMark
  },
  data() {
    return {
      PaymentSuccessImage
    };
  }
};
